<template>
  <div class="form-input-wrapper">
    <label class="form-label" :for="name"
      ><span>{{label}}</span></label
    >
    <!-- <div > -->
      <input
        v-model="value"
        type="checkbox"
        class="form-checkbox"
        :id="id"
        :name="name"
        @click="sendToParent"
      />
    <!-- </div> -->
  </div>
</template>

<script>
export default {
    props:["id", "name", "label", 'edit_value'],
    data() {
        return {
            value:false
        }
    },
    methods: {
      sendToParent(event){
        this.$emit('clicked')
      },
      // setValue(){
      //   if (this.edit_value != undefined) {
      //     this.value = this.edit_value;
      //   }
      // }
    },
    mounted() {
      // let vm = this;
      // vm.$nextTick(function () {
      //   this.inputType = vm.id;
      //   setTimeout(this.setValue, 1000);
      // //   setTimeout(this.prijedlogBrojPredmeta, 1000);
      // });
    },
};
</script>